export const ALCADA_PARAMS_LABEL = {
  quantidade_parcelas: 'Quantidade de parcelas',
  valor_total: 'Valor total',
  percentual_de_desconto: 'Percentual de desconto',
  valor_minimo_parcela: 'Valor mínimo da parcela',
  prazo_maximo_parcela1: 'Prazo máximo da 1ª parcela',
};
